import _asyncToGenerator from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/Users/vu/Documents/Repos.nosync/unfair-machine/node_modules/@babel/runtime/regenerator/index.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * =============================================================================
 */
import { env } from '@tensorflow/tfjs-core';
import { LazyIterator, OneToManyIterator } from './lazy_iterator';
import { StringIterator } from './string_iterator';
export var ByteChunkIterator = /*#__PURE__*/function (_LazyIterator) {
  _inherits(ByteChunkIterator, _LazyIterator);
  var _super = _createSuper(ByteChunkIterator);
  function ByteChunkIterator() {
    _classCallCheck(this, ByteChunkIterator);
    return _super.apply(this, arguments);
  }
  _createClass(ByteChunkIterator, [{
    key: "decodeUTF8",
    value:
    /**
     * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
     *
     * The byte arrays producetd from the ByteChunkIterator on which this is
     * called will be interpreted as concatenated.  No assumptions are made about
     * the boundaries of the incoming chunks, so a multi-byte UTF8 encoding of a
     * character may span the boundary between chunks.  This naturally happens,
     * for instance, when reading fixed-size byte arrays from a file.
     */
    function decodeUTF8() {
      return new Utf8Iterator(this);
    }
  }]);
  return ByteChunkIterator;
}(LazyIterator);
// ============================================================================
// The following private classes serve to implement the chainable methods
// on ByteChunkIterator.  Unfortunately they can't be placed in separate files,
// due to resulting trouble with circular imports.
// ============================================================================
// We wanted multiple inheritance, e.g.
//   class Utf8Iterator extends QueueIterator<string>, StringIterator
// but the TypeScript mixin approach is a bit hacky, so we take this adapter
// approach instead.
var Utf8Iterator = /*#__PURE__*/function (_StringIterator) {
  _inherits(Utf8Iterator, _StringIterator);
  var _super2 = _createSuper(Utf8Iterator);
  function Utf8Iterator(upstream) {
    var _this;
    _classCallCheck(this, Utf8Iterator);
    _this = _super2.call(this);
    _this.upstream = upstream;
    _this.impl = new Utf8IteratorImpl(upstream);
    return _this;
  }
  _createClass(Utf8Iterator, [{
    key: "summary",
    value: function summary() {
      return this.impl.summary();
    }
  }, {
    key: "next",
    value: function () {
      var _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.impl.next());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function next() {
        return _next.apply(this, arguments);
      }
      return next;
    }()
  }]);
  return Utf8Iterator;
}(StringIterator);
/**
 * Decode a stream of UTF8-encoded byte arrays to a stream of strings.
 *
 * This is tricky because the incoming byte array boundaries may disrupt a
 * multi-byte UTF8 character. Thus any incomplete character data at the end of
 * a chunk must be carried over and prepended to the next chunk before
 * decoding. Luckily with native decoder, TextDecoder in browser and
 * string_decoder in node, byte array boundaries are handled automatically.
 *
 * In the context of an input pipeline for machine learning, UTF8 decoding is
 * needed to parse text files containing training examples or prediction
 * requests (e.g., formatted as CSV or JSON). We cannot use the built-in
 * decoding provided by FileReader.readAsText() because here we are in a
 * streaming context, which FileReader does not support.
 *
 * @param upstream A `LazyIterator` of `Uint8Arrays` containing UTF8-encoded
 *   text, which should be interpreted as concatenated.  No assumptions are
 *   made about the boundaries of the incoming chunks, so a multi-byte UTF8
 *   encoding of a character may span the boundary between chunks.  This
 *   naturally happens, for instance, when reading fixed-size byte arrays from a
 *   file.
 */
var Utf8IteratorImpl = /*#__PURE__*/function (_OneToManyIterator) {
  _inherits(Utf8IteratorImpl, _OneToManyIterator);
  var _super3 = _createSuper(Utf8IteratorImpl);
  function Utf8IteratorImpl(upstream) {
    var _this2;
    _classCallCheck(this, Utf8IteratorImpl);
    _this2 = _super3.call(this);
    _this2.upstream = upstream;
    if (env().get('IS_BROWSER')) {
      _this2.decoder = new TextDecoder('utf-8');
    } else {
      // tslint:disable-next-line:no-require-imports
      var _require = require('string_decoder'),
        StringDecoder = _require.StringDecoder;
      _this2.decoder = new StringDecoder('utf8');
    }
    return _this2;
  }
  _createClass(Utf8IteratorImpl, [{
    key: "summary",
    value: function summary() {
      return "".concat(this.upstream.summary(), " -> Utf8");
    }
  }, {
    key: "pump",
    value: function () {
      var _pump = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var chunkResult, chunk, text;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.upstream.next();
            case 2:
              chunkResult = _context2.sent;
              if (!chunkResult.done) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return", false);
            case 7:
              chunk = chunkResult.value;
            case 8:
              if (env().get('IS_BROWSER')) {
                text = this.decoder.decode(chunk, {
                  stream: true
                });
              } else {
                text = this.decoder.write(Buffer.from(chunk.buffer));
              }
              this.outputQueue.push(text);
              return _context2.abrupt("return", true);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function pump() {
        return _pump.apply(this, arguments);
      }
      return pump;
    }()
  }]);
  return Utf8IteratorImpl;
}(OneToManyIterator);